import { Check, X } from 'lucide-react'
import { cn } from 'lib/utils'
import { GATE_META, type RubricGates } from '../../process/creative-process.types'
import { useScoreExplainer } from './score-explainer-context'

interface GateChipsProps {
  gates: RubricGates
}

/**
 * The four hard gates as pass/fail chips. A FAIL caps the verdict at no-ship, so
 * a red chip is the at-a-glance "this is why it won't ship" signal. Tapping a chip
 * opens the gate's explainer.
 */
export function GateChips({ gates }: GateChipsProps) {
  const { openExplainer } = useScoreExplainer()
  return (
    <div className="flex flex-wrap gap-1.5">
      {GATE_META.map(({ key, label }) => {
        const pass = gates[key] === 'PASS'
        return (
          <button
            key={key}
            type="button"
            onClick={() => openExplainer(`gate.${key}`, { showAction: !pass })}
            aria-label={`What the "${label}" gate means`}
            className={cn(
              'inline-flex cursor-help items-center gap-1 rounded-md px-1.5 py-0.5 text-[11px] font-medium transition-opacity hover:opacity-80',
              pass ? 'text-success bg-bg-3' : 'border border-destructive text-destructive'
            )}
          >
            {pass ? <Check size={12} /> : <X size={12} />}
            {label}
          </button>
        )
      })}
    </div>
  )
}
